export default "__VITE_ASSET__CO7CXrSE__"